import { createFileRoute } from '@tanstack/react-router';
import { CustomClerkSignInForm } from '../components/auth/CustomClerkSignInForm';
import { LoginPageLayout } from '../components/auth/LoginPageLayout';

export const Route = createFileRoute('/signin')({
  component: SignInRouteComponent,
});

function SignInRouteComponent() {
  return (
    <LoginPageLayout>
      <CustomClerkSignInForm
        signUpHref="/signup"
        afterSignInRedirect="/client/orders"
      />
    </LoginPageLayout>
  );
}
